import { v4 } from 'uuid';

import { UNATTACHED_DASHBOARD_ID, unitsTypes } from '../../constants/dashboards';
import {
  dashboardEventsFilterActions,
  dashboardFunnelStepFilterActions,
  dashboardRetentionEventFilterActions,
  dashboardRevenuePaymentFilterActions,
  dashboardUsersFilterActions,
} from '../../constants/filter';
import itemsReducer from './itemsReduser';
import * as fromItems from './itemsReduser';

// Необходима для дашбордов, в которых есть фаннелы и сформированных ранее,
// т.к. там при создании не формировался id в шагах (необходим для работы  D&D).
// Теперь в фаннелах id шагов формируется при создании.
const addIdIntoFunnelSteps = (units) =>
  units.map((unit) => {
    if (unit?.type !== unitsTypes.FUNNELS_TYPE) {
      return unit;
    }

    return {
      ...unit,
      compose: {
        ...unit.compose,
        funnels: {
          ...unit.compose.funnels,
          funnel: {
            ...unit.compose.funnels.funnel,
            steps: unit.compose.funnels.funnel.steps.map((step) => {
              if (step?.id) {
                return step;
              }

              return { ...step, id: v4() };
            }),
          },
        },
      },
    };
  });

export function generateUnits(n) {
  const unitsArr = [];
  for (let i = 0; i < n; i++) {
    const unit = {
      id: v4(),
      isFullSize: false,
      type: unitsTypes.EVENTS_TYPE,
      queries: [],
      compose: itemsReducer(undefined, { type: 'CREATE_INITIAL_EVENT' }),
      name: '',
    };
    unitsArr.push(unit);
  }
  return unitsArr;
}

const initialState = {
  updateTime: 0,
  editingDashboard: {},
  isExecuteEditingDashboard: false,
  isEditMode: false,
  isCreateMode: false,
  // хранится для каждого дешборда состояние раскрыт ли он.
  extendedDashboards: {
    [UNATTACHED_DASHBOARD_ID]: false,
  },
  name: '',
  units: [],
};

const compose = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_DASHBOARD_NAME':
      return {
        ...state,
        name: action.name,
      };

    case 'SAVE_DASHBOARD_SUCCESS':
    case 'UPDATE_DASHBOARD_SUCCESS':
    case 'RESET_DASHBOARD':
      return {
        ...initialState,
        units: generateUnits(1),
      };

    case 'SET_DASHBOARD_EXPAND':
      return {
        ...state,
        extendedDashboards: {
          ...state.extendedDashboards,
          [action.dashboardId]: !state.extendedDashboards[action.dashboardId],
        },
      };

    case 'SET_DASHBOARD_UNITS':
      return {
        ...state,
        units: action.units,
      };

    case 'SET_DASHBOARD_UNIT':
      return {
        ...state,
        units: [...state.units, ...generateUnits(1)],
      };

    case 'SET_DASHBOARD_UNIT_TYPE': {
      const indexUnit = state.units.findIndex(({ id }) => id === action.id);
      const changedUnit = state.units.find(({ id }) => id === action.id);

      return {
        ...state,
        units: [
          ...state.units.slice(0, indexUnit),
          {
            ...changedUnit,
            type: action.unitType,
            compose: itemsReducer(undefined, { type: 'CREATE_INITIAL_EVENT' }),
          },
          ...state.units.slice(indexUnit + 1),
        ],
      };
    }

    case 'SET_DASHBOARD_UNIT_NAME': {
      const unitIndex = state.units.findIndex(({ id }) => id === action.id);
      const unitByChangeName = state.units.find(({ id }) => id === action.id);
      return {
        ...state,
        units: [
          ...state.units.slice(0, unitIndex),
          { ...unitByChangeName, name: action.unitName },
          ...state.units.slice(unitIndex + 1),
        ],
      };
    }

    case 'DELETE_DASHBOARD_UNIT': {
      if (state.units.length === 1) {
        return {
          ...state,
        };
      }
      const indexDeletingUnit = state.units.findIndex(({ id }) => id === action.id);

      return {
        ...state,
        units: [
          ...state.units.slice(0, indexDeletingUnit),
          ...state.units.slice(indexDeletingUnit + 1),
        ],
      };
    }

    case 'CHANGE_SIZE_DASHBOARD_UNIT': {
      const indexChangingSizeUnit = state.units.findIndex(({ id }) => id === action.id);
      const changedSizeUnit = state.units.find(({ id }) => id === action.id);

      return {
        ...state,
        units: [
          ...state.units.slice(0, indexChangingSizeUnit),
          { ...changedSizeUnit, isFullSize: !changedSizeUnit.isFullSize },
          ...state.units.slice(indexChangingSizeUnit + 1),
        ],
      };
    }

    case 'SET_DASHBOARD_UPDATE_TIME':
      return {
        ...state,
        updateTime: Date.now(),
      };

    case 'SET_EDITING_DASHBOARD':
      return {
        ...state,
        editingDashboard: action.dashboard,
      };

    case 'TOGGLE_EDIT_DASHBOARD':
      return {
        ...state,
        isExecuteEditingDashboard: true,
      };

    case 'COMPOSE_DASHBOARD':
      return {
        ...state,
        name: action.dashboard.name,
        units: addIdIntoFunnelSteps(action.dashboard.units),
        isEditMode: true,
      };

    case 'COPY_DASHBOARD':
      return {
        ...state,
        name: `${action.dashboard.name}_copy`,
        units: addIdIntoFunnelSteps(action.dashboard.units),
        isCreateMode: true,
      };

    case 'CREATE_DASHBOARD_MODE':
      return {
        ...state,
        isCreateMode: true,
      };

    case 'RESET_DASHBOARD_MODE':
      return {
        ...state,
        isCreateMode: false,
        isEditMode: false,
      };

    case 'CREATE_DASHBOARD_SUCCESS':
    case 'CREATE_DASHBOARD_FAILURE':
    case 'UPDATE_DASHBOARD_FAILURE':
      return {
        ...state,
        isExecuteEditingDashboard: state.isExecuteEditingDashboard
          ? false
          : state.isExecuteEditingDashboard,
        editingDashboard: state.isExecuteEditingDashboard ? {} : state.editingDashboard,
      };

    case 'DASHBOARD_EVENTS_COMPOSE_ADD_EVENT':
    case 'DASHBOARD_EVENTS_COMPOSE_DUPLICATE_EVENT':
    case 'DASHBOARD_EVENTS_COMPOSE_REMOVE_EVENT':
    case 'DASHBOARD_EVENTS_COMPOSE_SET_GROUP_COLUMN':
    case 'DASHBOARD_EVENTS_COMPOSE_SET_EVENT_NAME':
    case 'DASHBOARD_EVENTS_COMPOSE_SET_EVENT_AGGREGATION_TYPE':
    case 'DASHBOARD_EVENTS_COMPOSE_SET_EVENT_AGGREGATION_COLUMN':
    case 'DASHBOARD_EVENTS_COMPOSE_SET_EVENT_SPLIT_COLUMN':
    case 'DASHBOARD_SET_OTHERS_FILTER':
    case dashboardEventsFilterActions.ADD_FILTER_CLAUSE:
    case dashboardEventsFilterActions.COPY_FILTER:
    case dashboardEventsFilterActions.REMOVE_FILTER:
    case dashboardEventsFilterActions.SET_FILTER_CLAUSE_FIELD:
    case dashboardEventsFilterActions.SET_FILTER_CLAUSE_VALUE:
    case dashboardEventsFilterActions.SET_CLAUSES_CONCAT_OPERATOR:
    case dashboardEventsFilterActions.SET_FILTER_CLAUSE_OPERATOR:
    case dashboardEventsFilterActions.SET_FILTER_VISIBILITY:
    case dashboardEventsFilterActions.REMOVE_FILTER_CLAUSE:
    case 'DASHBOARD_ADD_PERIOD':
    case 'DASHBOARD_DELETE_PERIOD':
    case 'DASHBOARD_SET_PERIOD':
    case 'DASHBOARD_SET_SHOW_PERIODS':
    case `DASHBOARD_SET_TEMPLATE_${unitsTypes.EVENTS_TYPE}`:
    case 'DASHBOARD_CHANGE_EVENT_VIEW':
    case 'DASHBOARD_EVENT_ENTER_FORMULA':
    case 'DASHBOARD_EVENT_ENTER_LEGEND_NAME':
    case 'DASHBOARD_EVENT_FORMULA_ONLY':
    case 'DASHBOARD_TOGGLE_EVENTS_CALC_TOTAL':
    case 'DASHBOARD_TOGGLE_EVENTS_TREND_LINE':
    case 'DASHBOARD_TOGGLE_EVENTS_AVERAGE_LINE':
    case 'DASHBOARD_TOGGLE_EVENTS_MEDIAN_LINE':
    case 'DASHBOARD_TOGGLE_EVENTS_ADAPTIVE':
    case 'DASHBOARD_TOGGLE_EVENTS_CUMULATIVE':
    case 'CREATE_INITIAL_EVENT':
    case 'DASHBOARD_CHANGE_EVENTS_COLUMN_CHART_SORTING':
    case `DASHBOARD_SET_TEMPLATE_${unitsTypes.USERS_TYPE}`:
    case 'DASHBOARD_CHANGE_USERS_EVENT':
    case 'DASHBOARD_SET_USERS_EVENT_COLUMNS_VALUE':
    case 'DASHBOARD_DELETE_USERS_EVENT_COLUMN':
    case 'DASHBOARD_ADD_USERS_EVENT_COLUMN':
    case 'DASHBOARD_AGGREGATE_USERS':
    case dashboardUsersFilterActions.SET_FILTER_VISIBILITY:
    case dashboardUsersFilterActions.ADD_FILTER_CLAUSE:
    case dashboardUsersFilterActions.COPY_FILTER:
    case dashboardUsersFilterActions.REMOVE_FILTER:
    case dashboardUsersFilterActions.REMOVE_FILTER_CLAUSE:
    case dashboardUsersFilterActions.SET_FILTER_CLAUSE_FIELD:
    case dashboardUsersFilterActions.SET_FILTER_CLAUSE_VALUE:
    case dashboardUsersFilterActions.SET_CLAUSES_CONCAT_OPERATOR:
    case dashboardUsersFilterActions.SET_FILTER_CLAUSE_OPERATOR:
    case `DASHBOARD_SET_TEMPLATE_${unitsTypes.REVENUE_TYPE}`:
    case 'SET_META_INFO_FOR_REVENUE':
    case 'DASHBOARD_SET_AMOUNT_FIELD':
    case 'DASHBOARD_REVENUE_COMPOSE_SET_GROUP_COLUMN':
    case 'DASHBOARD_CHANGE_REVENUE_QUERY_TYPE':
    case 'DASHBOARD_CHANGE_REVENUE_COLUMN_CHART_SORTING':
    case 'DASHBOARD_REVENUE_COMPOSE_SET_SPLIT_COLUMN':
    case 'DASHBOARD_ASSIGN_REVENUE_TYPE_QUERY':
    case dashboardRevenuePaymentFilterActions.ADD_FILTER_CLAUSE:
    case dashboardRevenuePaymentFilterActions.REMOVE_FILTER_CLAUSE:
    case dashboardRevenuePaymentFilterActions.REMOVE_FILTER:
    case dashboardRevenuePaymentFilterActions.SET_FILTER_CLAUSE_FIELD:
    case dashboardRevenuePaymentFilterActions.SET_FILTER_CLAUSE_VALUE:
    case dashboardRevenuePaymentFilterActions.SET_CLAUSES_CONCAT_OPERATOR:
    case dashboardRevenuePaymentFilterActions.SET_FILTER_CLAUSE_OPERATOR:
    case 'DASHBOARD_CHANGE_REVENUE_VIEW':
    case 'DASHBOARD_TOGGLE_REVENUE_CALC_TOTAL':
    case 'DASHBOARD_TOGGLE_REVENUE_TREND_LINE':
    case 'DASHBOARD_TOGGLE_REVENUE_AVERAGE_LINE':
    case 'DASHBOARD_TOGGLE_REVENUE_MEDIAN_LINE':
    case 'DASHBOARD_TOGGLE_REVENUE_ADAPTIVE':
    case 'DASHBOARD_REVENUE_SET_EXPAND':
    case dashboardRevenuePaymentFilterActions.SET_FILTER_VISIBILITY:
    case 'DASHBOARD_CHANGE_RETENTION_FIRST_EVENT':
    case 'DASHBOARD_CHANGE_RETENTION_RETURN_EVENT':
    case 'DASHBOARD_CHANGE_RETENTION_DIMENSION_TYPE':
    case 'DASHBOARD_CHANGE_RETENTION_VIEW':
    case 'DASHBOARD_TOGGLE_RETENTION_TREND_LINE':
    case 'DASHBOARD_TOGGLE_RETENTION_AVERAGE_LINE':
    case 'DASHBOARD_TOGGLE_RETENTION_MEDIAN_LINE':
    case 'DASHBOARD_TOGGLE_RETENTION_ADAPTIVE':
    case `DASHBOARD_SET_TEMPLATE_${unitsTypes.RETENTION_COMPLEX_TYPE}`:
    case 'DASHBOARD_CHANGE_RETENTION_COMPLEX_VIEW':
    case 'DASHBOARD_TOGGLE_RETENTION_COMPLEX_TREND_LINE':
    case 'DASHBOARD_TOGGLE_RETENTION_COMPLEX_AVERAGE_LINE':
    case 'DASHBOARD_TOGGLE_RETENTION_COMPLEX_MEDIAN_LINE':
    case 'DASHBOARD_TOGGLE_RETENTION_COMPLEX_ADAPTIVE':
    case 'DASHBOARD_CHANGE_RETENTION_COMPLEX_FIRST_EVENT':
    case 'DASHBOARD_CHANGE_RETENTION_COMPLEX_RETURN_EVENT':
    case 'DASHBOARD_CHANGE_RETENTION_COMPLEX_DIMENSION_TYPE':
    case dashboardRetentionEventFilterActions.ADD_FILTER_CLAUSE:
    case dashboardRetentionEventFilterActions.REMOVE_FILTER_CLAUSE:
    case dashboardRetentionEventFilterActions.SET_FILTER_CLAUSE_FIELD:
    case dashboardRetentionEventFilterActions.SET_FILTER_CLAUSE_VALUE:
    case dashboardRetentionEventFilterActions.SET_CLAUSES_CONCAT_OPERATOR:
    case dashboardRetentionEventFilterActions.SET_FILTER_CLAUSE_OPERATOR:
    case 'DASHBOARD_TOGGLE_RETENTION_COMPLEX_CUSTOM_SEQUENCE':
    case 'DASHBOARD_SET_RETENTION_COMPLEX_CUSTOM_SEQUENCE_TYPE':
    case 'DASHBOARD_CALCULATE_RETENTION_COMPLEX_CUSTOM_SEQUENCE':
    case 'DASHBOARD_CHANGE_RETENTION_COMPLEX_CUSTOM_SEQUENCE':
    case 'DASHBOARD_SET_RETENTION_COMPLEX_CUSTOM_SEQUENCE_FROM':
    case 'DASHBOARD_SET_RETENTION_COMPLEX_CUSTOM_SEQUENCE_TO':
    case dashboardRetentionEventFilterActions.SET_FILTER_VISIBILITY:
    case dashboardRetentionEventFilterActions.REMOVE_FILTER:
    case dashboardRetentionEventFilterActions.COPY_FILTER:
    case 'DASHBOARD_SET_RETENTION_COMPLEX_EXPOSURE_ERROR':
    case 'DASHBOARD_SELECT_FUNNEL':
    case 'DASHBOARD_CANCEL_UPDATE_FUNNEL':
    case 'DASHBOARD_UPDATE_SET_FUNNEL_NAME':
    case 'DASHBOARD_START_UPDATE_FUNNEL':
    case 'DASHBOARD_UPDATE_FUNNEL':
    case 'DASHBOARD_UPDATE_FUNNEL_SUCCESS':
    case 'DASHBOARD_UPDATE_FUNNEL_FAILURE':
    case 'DASHBOARD_DELETE_FUNNEL_SUCCESS':
    case 'DASHBOARD_UPDATE_FUNNEL_ADD_STEP':
    case 'DASHBOARD_UPDATE_FUNNEL_CHANGE_STEP_POSITION':
    case 'DASHBOARD_UPDATE_FUNNEL_SET_EVENT_NAME':
    case 'DASHBOARD_UPDATE_FUNNEL_SET_LEGEND_NAME':
    case 'DASHBOARD_UPDATE_TOGGLE_FUNNEL_ENABLED':
    case 'DASHBOARD_UPDATE_FUNNEL_SET_STEP_OPTIONAL_STATUS':
    case 'DASHBOARD_UPDATE_FUNNEL_SET_STEP_COUNT':
    case 'DASHBOARD_UPDATE_FUNNEL_SET_STEP_CLOSING_RANGE':
    case 'DASHBOARD_UPDATE_REMOVE_FUNNEL_STEP':
    case 'DASHBOARD_UPDATE_FUNNEL_SET_GLOBAL_CLOSING_RANGE':
    case 'DASHBOARD_FUNNEL_SELECT_DUPLICATE_FUNNEL':
    case dashboardFunnelStepFilterActions.ADD_FILTER_CLAUSE:
    case dashboardFunnelStepFilterActions.REMOVE_FILTER_CLAUSE:
    case dashboardFunnelStepFilterActions.SET_FILTER_CLAUSE_FIELD:
    case dashboardFunnelStepFilterActions.SET_FILTER_CLAUSE_VALUE:
    case dashboardFunnelStepFilterActions.SET_CLAUSES_CONCAT_OPERATOR:
    case dashboardFunnelStepFilterActions.SET_FILTER_CLAUSE_OPERATOR:
    case 'DASHBOARD_SET_CONVERSION_INTERVAL':
    case 'DASHBOARD_CHANGE_FUNNEL_VIEW': {
      const index = state.units.findIndex((u) => u.id === action.unitId);
      const unit = {
        ...state.units[index],
        compose: itemsReducer(state.units[index].compose, action),
      };
      const modifiedUnits = [...state.units];

      modifiedUnits.splice(index, 1, unit);

      return {
        ...state,
        units: modifiedUnits,
      };
    }

    default:
      return state;
  }
};

export default compose;

export const getUpdateTime = (state) => state.updateTime;

export const getExtended = (state) => state.extendedDashboards;

export const getEditingDashboard = (state) => state.editingDashboard;

export const getExecuteEditingDashboard = (state) => state.isExecuteEditingDashboard;

export const getDashboardName = (state) => state.name;

export const getEditingMode = (state) => state.isEditMode;

export const getCreatingMode = (state) => state.isCreateMode;

export const getUnits = (state) => state.units;

export const getIds = (state, unitId) =>
  fromItems.getIds(state.units.find((u) => u.id === unitId).compose);

export const getGroupColumn = (state, unitId) =>
  fromItems.getGroupColumn(state.units.find((u) => u.id === unitId).compose);

export const getSql = (state, unitId, id) =>
  fromItems.getSql(state.units.find((u) => u.id === unitId).compose, id);

export const getError = (state, unitId, id) =>
  fromItems.getError(state.units.find((u) => u.id === unitId).compose, id);

export const getName = (state, unitId, id) =>
  fromItems.getName(state.units.find((u) => u.id === unitId).compose, id);

export const getUniqueChar = (state, unitId, id) =>
  fromItems.getUniqueChar(state.units.find((u) => u.id === unitId).compose, id);

export const getPeriodsState = (state, unitId, id) =>
  fromItems.getPeriodsState(state.units.find((u) => u.id === unitId).compose, id);

export const getFilter = (state, unitId, id) =>
  fromItems.getFilter(state.units.find((u) => u.id === unitId).compose, id);

export const getAggregationColumn = (state, unitId, id) =>
  fromItems.getAggregationColumn(state.units.find((u) => u.id === unitId).compose, id);

export const getAggregationType = (state, unitId, id) =>
  fromItems.getAggregationType(state.units.find((u) => u.id === unitId).compose, id);

export const getSplitColumn = (state, unitId, id) =>
  fromItems.getSplitColumn(state.units.find((u) => u.id === unitId).compose, id);

export const getEvents = (state, unitId) =>
  fromItems.getEvents(state.units.find((u) => u.id === unitId).compose);

export const getIdUsingTemplate = (state, unitId) =>
  fromItems.getIdUsingTemplate(state.units.find((u) => u.id === unitId).compose);

export const getEventsCsv = (state, unitId) =>
  fromItems.getEventsCsv(state.units.find((u) => u.id === unitId).compose);

export const getOthersFilter = (state, unitId, id) =>
  fromItems.getOthersFilter(state.units.find((u) => u.id === unitId).compose, id);

export const getEventView = (state, unitId) =>
  fromItems.getEventView(state.units.find((u) => u.id === unitId).compose);

export const getEnteredFormula = (state, unitId) =>
  fromItems.getEnteredFormula(state.units.find((u) => u.id === unitId).compose);

export const getEnteredLegendName = (state, unitId) =>
  fromItems.getEnteredLegendName(state.units.find((u) => u.id === unitId).compose);

export const getIsFormulaOnly = (state, unitId) =>
  fromItems.getIsFormulaOnly(state.units.find((u) => u.id === unitId).compose);

export const getEventOptions = (state, unitId) =>
  fromItems.getEventOptions(state.units.find((u) => u.id === unitId).compose);

export const getDashboardRetentionSimpleFirstEvent = (state, unitId) =>
  fromItems.getDashboardRetentionSimpleFirstEvent(state.units.find((u) => u.id === unitId).compose);

export const getDashboardRetentionSimpleReturnEvent = (state, unitId) =>
  fromItems.getDashboardRetentionSimpleReturnEvent(
    state.units.find((u) => u.id === unitId).compose
  );

export const getDashboardRetentionSimpleDimensionType = (state, unitId) =>
  fromItems.getDashboardRetentionSimpleDimensionType(
    state.units.find((u) => u.id === unitId).compose
  );

export const getDashboardRetentionSimpleOptions = (state, unitId) =>
  fromItems.getDashboardRetentionSimpleOptions(state.units.find((u) => u.id === unitId).compose);

export const getFirstEvent = (state, unitId) =>
  fromItems.getFirstEvent(state.units.find((u) => u.id === unitId).compose);

export const getFirstEventFilter = (state, unitId) =>
  fromItems.getFirstEventFilter(state.units.find((u) => u.id === unitId).compose);

export const getReturnEvent = (state, unitId) =>
  fromItems.getReturnEvent(state.units.find((u) => u.id === unitId).compose);

export const getReturnEventFilter = (state, unitId) =>
  fromItems.getReturnEventFilter(state.units.find((u) => u.id === unitId).compose);

export const getUseLatestProfile = (state, unitId) =>
  fromItems.getUseLatestProfile(state.units.find((u) => u.id === unitId).compose);

export const getDimensionType = (state, unitId) =>
  fromItems.getDimensionType(state.units.find((u) => u.id === unitId).compose);

export const getFilterFor = (state, unitId, eventIndex) =>
  fromItems.getFilterFor(state.units.find((u) => u.id === unitId).compose, eventIndex);

export const isCustomSequenceEnabled = (state, unitId) =>
  fromItems.isCustomSequenceEnabled(state.units.find((u) => u.id === unitId).compose);

export const getCustomSequenceType = (state, unitId) =>
  fromItems.getCustomSequenceType(state.units.find((u) => u.id === unitId).compose);

export const getCustomSequence = (state, unitId) =>
  fromItems.getCustomSequence(state.units.find((u) => u.id === unitId).compose);

export const getCustomSequenceDimensions = (state, unitId) =>
  fromItems.getCustomSequenceDimensions(state.units.find((u) => u.id === unitId).compose);

export const getRetentionIdUsingTemplate = (state, unitId) =>
  fromItems.getIdUsingTemplate(state.units.find((u) => u.id === unitId).compose);

export const getRetentionComplexSQL = (state, unitId) =>
  fromItems.getRetentionComplexSQL(state.units.find((u) => u.id === unitId).compose);

export const getRetentionError = (state, unitId) =>
  fromItems.getError(state.units.find((u) => u.id === unitId).compose);

export const getRetentionComplexOptions = (state, unitId) =>
  fromItems.getRetentionComplexOptions(state.units.find((u) => u.id === unitId).compose);

export const getEvent = (state, unitId) =>
  fromItems.getEvent(state.units.find((u) => u.id === unitId).compose);

export const getColumns = (state, unitId) =>
  fromItems.getColumns(state.units.find((u) => u.id === unitId).compose);

export const isAggregateEnabled = (state, unitId) =>
  fromItems.isAggregateEnabled(state.units.find((u) => u.id === unitId).compose);

export const getUserFilter = (state, unitId) =>
  fromItems.getUserFilter(state.units.find((u) => u.id === unitId).compose);

export const getIdUsingUsersTemplate = (state, unitId) =>
  fromItems.getIdUsingUsersTemplate(state.units.find((u) => u.id === unitId).compose);

export const getUsersSQL = (state, unitId) =>
  fromItems.getUsersSQL(state.units.find((u) => u.id === unitId).compose);

export const getUsersError = (state, unitId) =>
  fromItems.getUsersError(state.units.find((u) => u.id === unitId).compose);

export const getAmountField = (state, unitId) =>
  fromItems.getAmountField(state.units.find((u) => u.id === unitId).compose);

export const getAmountFields = (state, unitId) =>
  fromItems.getAmountFields(state.units.find((u) => u.id === unitId).compose);

export const getRevenueGroupColumn = (state, unitId) =>
  fromItems.getRevenueGroupColumn(state.units.find((u) => u.id === unitId).compose);

export const getRevenueSplitColumn = (state, unitId) =>
  fromItems.getRevenueSplitColumn(state.units.find((u) => u.id === unitId).compose);

export const getQueryType = (state, unitId) =>
  fromItems.getQueryType(state.units.find((u) => u.id === unitId).compose);

export const getPaymentFilter = (state, unitId) =>
  fromItems.getPaymentFilter(state.units.find((u) => u.id === unitId).compose);

export const getOptions = (state, unitId) =>
  fromItems.getOptions(state.units.find((u) => u.id === unitId).compose);

export const isUpdating = (state, unitId) =>
  fromItems.isUpdating(state.units.find((u) => u.id === unitId).compose);

export const getUpdating = (state, unitId) =>
  fromItems.getUpdating(state.units.find((u) => u.id === unitId).compose);

export const getUpdatingId = (state, unitId) =>
  fromItems.getUpdatingId(state.units.find((u) => u.id === unitId).compose);

export const getFunnelConversionInterval = (state, unitId) =>
  fromItems.getFunnelConversionInterval(state.units.find((u) => u.id === unitId).compose);

export const getFunnelView = (state, unitId) =>
  fromItems.getFunnelView(state.units.find((u) => u.id === unitId).compose);
